import { Button, Card, Empty, List, Popover, Typography } from 'antd';
import { NavLink } from 'react-router-dom';
import { useMemo } from 'react';
import { AnnouncementStatus, formatters } from '@/core';
import {
  AnnouncementState,
  useGetAnnouncementListQuery,
} from '@/redux/announcements';
import { PAGINATION_DEFAULT, RichTextValue } from '@/components';
import { useTranslation } from 'react-i18next';
import styles from './AnnouncementsOverviewPanel.module.scss';
import { orderBy } from 'lodash';
const { Title, Text } = Typography;

export function AnnouncementsOverviewPanel() {
  const { data, isFetching } = useGetAnnouncementListQuery({
    statuses: [AnnouncementStatus.Published],
  });
  const { t } = useTranslation();
  const announcements = useMemo(
    () => orderBy(data ?? [], (x) => x.createdAt, 'desc'),
    [data],
  );

  if (!announcements.length || isFetching) {
    return <Empty />;
  }

  return (
    <List
      pagination={PAGINATION_DEFAULT}
      dataSource={announcements}
      renderItem={(announcement: AnnouncementState) => (
        <List.Item>
          <Card
            title={
              <NavLink to={`/announcements/${announcement.id}`}>
                <Title level={4}>{announcement.title}</Title>
              </NavLink>
            }
            style={{ width: '100%' }}
          >
            <Text type="secondary">
              {formatters.dateTime(announcement.createdAt)}
            </Text>
            <div className="mt-3">
              <Popover
                trigger="click"
                placement="right"
                className={styles.popover}
                content={
                  <div style={{ maxWidth: 420, minWidth: 200 }}>
                    <Text type="secondary">
                      {formatters.dateTime(announcement.createdAt)}
                    </Text>

                    <RichTextValue
                      label={false}
                      value={announcement.body}
                      ownerId={announcement.id}
                      ownerType="Announcement"
                    />
                  </div>
                }
              >
                <Button type="link" className={styles.link}>
                  {t('announcements.overview.view')}
                </Button>
              </Popover>
            </div>
          </Card>
        </List.Item>
      )}
    />
  );
}
